import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import FieldWrapper from './StyledFieldWrapper';
import Error from './StyledError';
import css from '@/components/FormElements/Checkbox.module.css';
import TickIcon from '@/styles/Icons/TickIcon';
import { classNames } from '@/utils/helpers/classNames';

const CheckboxWrapper = styled(FieldWrapper)`
  @media (min-width: 1200px) {
    /* justify-content: center; */
  }

  .error {
    margin-top: -15px;
  }
`;

const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  margin: 0;
  font-size: 14px;
  cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
  color: ${props => (props.$disabled ? props.theme.textLight : props.theme.text)};
`;

const StyledCheckbox = styled.input`
  appearance: none;
  outline: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  width: 22px;
  height: 22px;
  border: 1px solid;
  margin-right: 15px;
  border-color: ${props =>
    props.disabled
      ? props.theme.backgroundDark
      : props.checked
      ? !props.inverted
        ? props.theme.accent
        : props.theme.white
      : (props.isRequired && props.touched && (!props.inverted ? props.theme.brandDark : props.theme.textLighter)) ||
        (!props.inverted ? props.theme.backgroundDarker : props.theme.textLighter)};
  background-color: ${props => (props.disabled ? props.theme.backgroundLight : 'transparent')};
`;

const Checkbox = ({
  label,
  labelElement,
  isRequired,
  touched,
  error,
  checked,
  indeterminate,
  id,
  onChange,
  className,
  invertedColor,
  disabled,
  ariaLabel,
  children
}) => {
  const inputRef = useRef(null);

  // Set `indeterminate` via ref since it's DOM-only, not an HTML attribute
  // Showed only if checkbox in `unchecked` status
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = Boolean(indeterminate) && !checked;
    }
  }, [indeterminate, checked]);

  return (
    <div className={className}>
      <CheckboxWrapper>
        <StyledLabel htmlFor={id} checked={checked} $disabled={disabled}>
          <div className={css.checkboxContainer}>
            <StyledCheckbox
              ref={inputRef}
              type="checkbox"
              inverted={invertedColor}
              isRequired={isRequired}
              touched={touched}
              id={id}
              checked={checked}
              onChange={onChange}
              disabled={disabled}
              aria-label={ariaLabel}
            />
            {checked && (
              <div
                className={classNames({
                  [css.iconContainer]: true,
                  [css.iconChecked]: checked,
                  [css.inverted]: invertedColor,
                  [css.disabled]: disabled
                })}
              >
                <TickIcon />
              </div>
            )}
            {!checked && indeterminate && (
              <div
                className={classNames({
                  [css.indeterminateContainer]: true,
                  [css.iconChecked]: true,
                  [css.inverted]: invertedColor
                })}
              >
                <span className={css.indeterminateMark} />
              </div>
            )}
          </div>
          {label || labelElement || children}
        </StyledLabel>
      </CheckboxWrapper>
      <CheckboxWrapper>{touched && error && <Error className="error">{error}</Error>}</CheckboxWrapper>
    </div>
  );
};

export default Checkbox;
